import React from "react";
import classes from "./option.module.css";
import TileListShimmer from "./tileList.shimmer";
import Shimmer from "../../components/Shimmer";

const OptionShimmer = (props) => {
  return (
    <div className={classes.root}>
      <span className={classes.swatchtitle}>
        <Shimmer width="100%" />
      </span>
      <TileListShimmer />
    </div>
  );
};

export default OptionShimmer;
